import _default from './oneLine';
export { _default as default };
